import React, { Component } from 'react';
import ResidenceItem from "./ResidenceItem"

class ResidencesList extends Component {

	render() {
		return (
			<div className="ResidencesList">
				{this.props.residences.map((residence, index) => <ResidenceItem key={index} residence={residence}
																				onResidenceSelected={this.props.onResidenceSelected}
																				onEditClick={this.props.onEditClick}
																				onDeleteClick={this.props.onDeleteClick}
				/>)}
			</div>
		)
	}
}

export default ResidencesList


// WEBPACK FOOTER //
// ./src/components/shared/ResidencesList.js